/**
 * Employee UI splits invitation forms_to_fill into 記入書類 vs 確認書類.
 * Confirmation docs are agree/preview oriented (no free-form data entry in the checklist UX).
 */

const CONFIRMATION_FORM_CODES: ReadonlySet<string> = new Set([
  'FF002', // 雇入通知書兼雇用契約書
  'FF004', // 誓約書
  'FF009', // キャリアアップ申込書類
  'FF010', // パスワード取り扱いについての同意書
  'FF011', // 健康情報システムの書類（建災防-様式-ずい道）
  'FF013', // 認印についての同意書
  'FF014', // 雇入れ時教育確認書
  'FF015', // 前職照会同意書
]);

function normalizeFormCode(formCode: string | undefined | null): string {
  return formCode?.trim().toUpperCase() ?? '';
}

export function isConfirmationFormCode(formCode: string | undefined | null): boolean {
  const code = normalizeFormCode(formCode);
  return code.length > 0 && CONFIRMATION_FORM_CODES.has(code);
}

export function isFillInFormCode(formCode: string | undefined | null): boolean {
  const code = normalizeFormCode(formCode);
  return code.length > 0 && !CONFIRMATION_FORM_CODES.has(code);
}

export function partitionFormsByCategory<T extends { formCode: string }>(
  forms: readonly T[] | undefined | null
): { fillIn: T[]; confirmation: T[] } {
  const fillIn: T[] = [];
  const confirmation: T[] = [];
  if (!forms) return { fillIn, confirmation };
  for (const form of forms) {
    if (isConfirmationFormCode(form.formCode)) confirmation.push(form);
    else fillIn.push(form);
  }
  return { fillIn, confirmation };
}

export function confirmationFormCodes(): readonly string[] {
  return [...CONFIRMATION_FORM_CODES];
}
